import React, { Component } from 'react';
import { toast } from 'react-toastify';
import cn from 'classnames';

import { fetchPurchaseTaxes } from 'api';
import BaseModal from '../BaseModal';
import Spinner from 'components/Spinner';

import styles from './styles.module.scss';

class PurchaseTaxesModal extends Component {
  state = {
    isOpen: false,
    loading: false,
    data: null,
  };

  openModal = () => {
    this.setState({ isOpen: true });
    if (!this.state.data) {
      this.loadTaxes();
    }
  };
  closeModal = () => this.setState({ isOpen: false });

  loadTaxes = async () => {
    const { purchaseId } = this.props;
    this.setState({ loading: true });

    try {
      const response = await fetchPurchaseTaxes(purchaseId);
      this.setState({ data: response.data });
    } catch (err) {
      toast.error(err.message);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { isOpen, data, loading } = this.state;
    return (
      <>
        <button
          className={cn('btn', 'btn-default', styles.button)}
          onClick={this.openModal}
        >
          Show Taxes
        </button>
        <BaseModal
          title="Tax Breakdown"
          onClose={this.closeModal}
          isOpen={isOpen}
          confirmBtnText=""
          cancelBtnText=""
        >
          <table className="table">
            <thead>
              <tr>
                <th>Customer Number</th>
                <th>Invoice Number</th>
                <th>State Code</th>
                <th>Tax Amount</th>
                <th>Tax Type Description</th>
                <th>Tax Type Code</th>
              </tr>
            </thead>
            <tbody>
              {data?.taxes?.map((item, i) => {
                const {
                  customer_number,
                  invoice_number,
                  state_code,
                  tax_amount,
                  tax_type_desc,
                  tax_type_code,
                } = item;
                return (
                  <tr key={i}>
                    <td>{customer_number}</td>
                    <td>{invoice_number}</td>
                    <td>{state_code}</td>
                    <td>${tax_amount}</td>
                    <td>{tax_type_desc}</td>
                    <td>{tax_type_code}</td>
                  </tr>
                );
              })}
              {data && !data?.taxes?.length && (
                <tr>
                  <td colSpan={6}>No results</td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="flex-justify-space-between mar-t">
            <p>
              <b>Transaction Id:</b> {data?.transaction_id}
            </p>
            <p>
              <b>Total Tax: ${data?.total_tax}</b>
            </p>
          </div>
          <Spinner showLoader={loading} />
        </BaseModal>
      </>
    );
  }
}

export default PurchaseTaxesModal;
